import {useState, useEffect, useMemo} from 'react';
import {COUNTRY_LANGUAGES_CODES} from '@/utils/constants/globalConstants';

/**
 * Hook to manage language state for rewards display
 * Derives languages from country code or Redux; never uses the MX stub service.
 */
export const useRewardsDisplayLanguages = ({
  countryCode,
  displayContentLanguages
}) => {
  const [localLanguages, setLocalLanguages] = useState([]);

  useEffect(() => {
    const normalizedCountryCode = (countryCode || '').toString().toUpperCase();
    // Wait for a real country code before resolving languages (avoids stub/race)
    if (!normalizedCountryCode) {
      setLocalLanguages([]);
      return;
    }

    const countryLangs = COUNTRY_LANGUAGES_CODES[normalizedCountryCode];
    if (countryLangs?.length > 0) {
      setLocalLanguages(countryLangs);
      return;
    }
    if (displayContentLanguages?.length > 0) {
      setLocalLanguages(displayContentLanguages);
      return;
    }

    setLocalLanguages([]);
  }, [countryCode, displayContentLanguages]);

  const languages = useMemo(
    () =>
      (localLanguages || []).map((l) => ({
        code: l.code,
        language: l.language || l.title
      })),
    [localLanguages]
  );

  return {languages, localLanguages};
};
